import * as React from "react";
import { Ref, SVGProps, forwardRef } from "react";
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    ref={ref}
    className="social-icon"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        className="primary-path"
        fill="#111"
        fillOpacity={0.44}
        d="M24 12.5c0-6.627-5.373-12-12-12S0 5.873 0 12.5c0 5.628 3.874 10.35 9.101 11.647v-7.98H6.627V12.5H9.1v-1.58c0-4.085 1.848-5.978 5.858-5.978.76 0 2.072.15 2.609.298v3.325c-.283-.03-.775-.045-1.386-.045-1.968 0-2.728.745-2.728 2.683V12.5h3.92l-.674 3.667h-3.246v8.245C19.395 23.695 24 18.635 24 12.5Z"
      />
      <path
        fill="#fff"
        d="m16.7 16.167.673-3.667h-3.92v-1.297c0-1.938.76-2.683 2.729-2.683a15.4 15.4 0 0 1 1.386.045V5.24c-.537-.15-1.849-.299-2.609-.299-4.01 0-5.858 1.893-5.858 5.978v1.58H6.626v3.667h2.475v7.98a12.027 12.027 0 0 0 4.353.265v-8.245H16.7Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .5h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
